import map from "lodash/map";
import React, { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { groupExercisesByComplex } from "../../../../utils/complex";
import { groupExercisesBySection } from "../../../../utils/prefix-calculator";
import { splitSections } from "../../../../utils/section-types";
import SectionSeparator from "../../../athlete-portal/calendar/components/EditMode/ExerciseEditor/SectionSeparator";
import WorkoutNoteBlock from "../../../athlete-portal/calendar/components/EditMode/ExerciseEditor/WorkoutNoteBlock";
import ExercisePreview from "./exercise-preview";

const WorkoutPreview = (props) => {
  const {
    exercises = [],
    workoutNumber,
    week: weekProp,
    locals,
    sessions,
    notSingleWorkout,
  } = props;
  const { t } = useTranslation("dashboard");
  const week = weekProp ?? locals.query?.week ?? 0;

  const exerciseIds = exercises.map((exercise) => exercise._id);

  const sessionToFindWorkName = sessions.find(
    (item) =>
      Number(week) === Number(item.week) &&
      arraysEqual(item.exercises, exerciseIds)
  );

  const workoutName =
    sessionToFindWorkName && sessionToFindWorkName.workoutName
      ? t("programPreview.workoutNumberWithName", {
          number: workoutNumber,
          name: sessionToFindWorkName.workoutName,
        })
      : t("programPreview.workoutNumber", { number: workoutNumber });

  const groupedExercises = groupExercisesByComplex(exercises);

  const sessionSections = (locals.editSections || []).filter(
    (s) =>
      s.cycle &&
      String(s.cycle.id) === String(locals.editCycle._id) &&
      s.cycle.program === locals.activeProgramIndex + 1 &&
      s.cycle.programWeek === Number(week) &&
      s.cycle.programSession === Number(workoutNumber)
  );
  const { sections: normalSessionSections, note: sessionNote } =
    splitSections(sessionSections);
  const sectionByFirstExerciseId = {};
  const emptySections = [];
  groupExercisesBySection(exercises, normalSessionSections).forEach((group) => {
    if (!group.section) return;
    if (group.exercises.length) {
      sectionByFirstExerciseId[group.exercises[0]._id] = group.section;
    } else {
      emptySections.push(group.section);
    }
  });

  return (
    <article className="Workout-Preview">
      <header className={`${!notSingleWorkout ? "top-0!" : ""}`}>
        <p className="s2">
          {notSingleWorkout ? workoutName : t("programPreview.singleWorkout")}
        </p>
      </header>
      <div className={`body workout-${workoutNumber}-list`}>
        <WorkoutNoteBlock note={sessionNote} editable={false} />
        <ul className="exercises-list">
          {map(groupedExercises, (exercise, idx) => {
            if (!exercise) return null;
            return (
              <Fragment key={exercise._id}>
                {sectionByFirstExerciseId[exercise._id] && (
                  <SectionSeparator
                    section={sectionByFirstExerciseId[exercise._id]}
                    editable={false}
                    nameEditable={false}
                  />
                )}
                <ExercisePreview
                  exercise={exercise}
                  exercises={groupedExercises}
                  exerciseOrder={idx}
                  locals={locals}
                />
              </Fragment>
            );
          })}
          {emptySections.map((section) => (
            <SectionSeparator
              key={section._id}
              section={section}
              editable={false}
              nameEditable={false}
            />
          ))}
        </ul>
      </div>
    </article>
  );
};

export default WorkoutPreview;

/**
 * Function to check if two arrays are equal
 * @param {*} arr1
 * @param {*} arr2
 * @returns
 */
const arraysEqual = (arr1, arr2) => {
  if (!arr1 || !arr2) return false;
  if (arr1.length !== arr2.length) return false;
  return arr1.every((val) => arr2.includes(val));
};
